var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 74") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M175,0H25C11.193,0,0,11.193,0,25v166.656c0,3.258,1.89,6.221,4.844,7.594 c1.101,0.492,2.293,0.748,3.5,0.75c1.982-0.004,3.899-0.713,5.406-2l48.969-41.969c4.532-3.891,10.308-6.03,16.281-6.031h96 c13.807,0,25-11.193,25-25V25C200,11.193,188.807,0,175,0z M183.344,125c-0.018,4.602-3.742,8.326-8.344,8.344H79 c-9.948,0.006-19.567,3.563-27.125,10.031l-35.219,30.188V25c0.017-4.601,3.743-8.327,8.344-8.344h150 c4.602,0.017,8.326,3.743,8.344,8.344V125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M141.656,49.031H58.344c-4.6-0.282-8.557,3.218-8.838,7.818c-0.281,4.6,3.218,8.557,7.818,8.838 c0.34,0.021,0.681,0.021,1.021,0h83.313c4.6,0.282,8.557-3.218,8.838-7.818c0.283-4.599-3.219-8.557-7.816-8.838 C142.337,49.01,141.996,49.01,141.656,49.031z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M141.656,82.375H58.344c-4.6-0.282-8.557,3.218-8.838,7.818c-0.282,4.599,3.218,8.557,7.817,8.838 c0.34,0.021,0.681,0.021,1.021,0h83.313c4.6,0.282,8.557-3.218,8.838-7.818c0.282-4.599-3.218-8.557-7.815-8.838 C142.337,82.354,141.996,82.354,141.656,82.375z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.18525bc61dfbb47fe837f36e76beb94a.svg";
export { ForwardRef as ReactComponent };